export enum AppraisalTaskStatus {
  Open = 0,
  InProgress = 1,
  Done = 2
}
